import { render, staticRenderFns } from "./NeuesProjekt.vue?vue&type=template&id=01057d46&"
import script from "./NeuesProjekt.vue?vue&type=script&lang=js&"
export * from "./NeuesProjekt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports